import { Navigate, useLocation } from "react-router-dom";
import { getLanguageFromPath, getLocalizedPath } from "../utils/urlUtils";

/**
 * Redirects /discover URLs (including language-prefixed ones) to the home page.
 */
export function DiscoverRedirect(): JSX.Element {
  const location = useLocation();
  const language = getLanguageFromPath(location.pathname);
  const homePath = getLocalizedPath("/", language);

  return <Navigate to={homePath + location.search} replace />;
}
